export const ACCOUNT_MSG_TYPE_INFO = 'info'
export const ACCOUNT_MSG_TYPE_ALERT = 'alert'
export const ACCOUNT_MSG_TYPE_ESTIMATE = 'estimate'

export const ESTIMATED_DATE_MSG = 'Expected payout: [{{withdrawal_date}}]'

export const DESCRIPTION_TO_MSG_PRESSETS = [
  {
    type: ACCOUNT_MSG_TYPE_INFO,
    description: '',
    account_message: 'Your withdrawal request is in queue and will be processed shortly.'
  },
  {
    type: ACCOUNT_MSG_TYPE_ESTIMATE,
    description: '',
    account_message: ESTIMATED_DATE_MSG,
  },
  {
    type: ACCOUNT_MSG_TYPE_ALERT,
    description: 'Waiting for docs!!!',
    account_message: 'We are awaiting your documents. Please check your email for our message.'
  },
  {
    type: ACCOUNT_MSG_TYPE_INFO,
    description: 'Sport checking',
    account_message: 'Your withdrawal request is under sports betting review and will be processed as soon as possible.'
  },
  {
    type: ACCOUNT_MSG_TYPE_INFO,
    description: 'Provider`s check',
    account_message: 'The gaming session is currently under review by the provider. Please note that this process may take from 3 to 14 business days.'
  },
  {
    type: ACCOUNT_MSG_TYPE_INFO,
    description: 'Check',
    account_message: 'The withdrawal request is under review by the Risk Department and will be processed as soon as possible.'
  },
  {
    type: ACCOUNT_MSG_TYPE_INFO,
    description: 'Withdrawal —— (verify)',
    account_message: '',
  },
  {
    type: ACCOUNT_MSG_TYPE_INFO,
    description: 'For verification',
    account_message: 'Your withdrawal request is in queue and will be processed shortly',
  },
  {
    type: ACCOUNT_MSG_TYPE_ALERT,
    description: 'Unwagered deposit',
    account_message: 'You need to meet the deposit wagering requirements. Please check your email for our message.',
  },
  {
    type: ACCOUNT_MSG_TYPE_ALERT,
    description: 'Incorrect payment method',
    account_message: 'Incorrect payment method. Please check your email for our message.',
  },
  {
    type: ACCOUNT_MSG_TYPE_ALERT,
    description: 'Combine withdrawals',
    account_message: 'Please combine your withdrawal requests. Details have been sent to your email.',
  },
  {
    type: ACCOUNT_MSG_TYPE_ALERT,
    description: 'Split withdraw',
    account_message: 'The transaction was unsuccessful. Please split the withdrawals. Details have been sent to your email.',
  },
  {
    type: ACCOUNT_MSG_TYPE_INFO,
    description: 'Extra winning from No deposit Bonus',
    account_message: 'Withdrawal cancelled due to balance adjustment in accordance with bonus max withdrawal terms.\nDetails have been sent to your email.',
  },
  {
    type: ACCOUNT_MSG_TYPE_INFO,
    description: 'Cancel: Verification failed',
    account_message: '',
  },
  {
    type: ACCOUNT_MSG_TYPE_ALERT,
    description: 'Transaction expired',
    account_message: 'The Interac transaction has expired. Please resubmit the withdrawal request.',
  },
  {
    type: ACCOUNT_MSG_TYPE_ALERT,
    description: 'Blacklisted',
    account_message: 'The transaction was unsuccessful. Details have been sent to your email.',
  },
  {
    type: ACCOUNT_MSG_TYPE_ALERT,
    description: 'Incorrect payment details',
    account_message: 'Incorrect payment details. Please check your email for our message.',
  },
  {
    type: ACCOUNT_MSG_TYPE_INFO,
    description: '',
    account_message: 'Your withdrawal is being processed. Please allow up to 5 business days for completion.',
  },
]

export const DESCRIPTION_PRESETS = DESCRIPTION_TO_MSG_PRESSETS
  .filter(preset => !!preset.description)

export const MESSAGE_PRESETS = DESCRIPTION_TO_MSG_PRESSETS
  .filter(preset => !!preset.account_message)
  .map(preset => ({ type: preset.type, message: preset.account_message }))
